import { Action } from 'redux';
import { put, select } from '@redux-saga/core/effects';
import { CheckoutActions, CheckoutActionTypes } from '../checkout.types';
import { ACTION_CREATOR_NAME, userHelper, errorToBasketErrorModel } from 'helpers';
import { AppState, ErrorAction } from '../../root.types';
import { api } from 'repositories/api';
import { BasketSagaReturnType } from 'store/sagaHelpers';

export interface SetDeliverNotBeforeAction extends Action<CheckoutActionTypes.SET_DELIVER_NOT_BEFORE> {
    date: Date;
    isQuickestDate: boolean;
}

export interface SetDeliverNotBeforeActionStart extends Action<CheckoutActionTypes.SET_DELIVER_NOT_BEFORE_START> {
}

export interface SetDeliverNotBeforeActionSuccess extends Action<CheckoutActionTypes.SET_DELIVER_NOT_BEFORE_SUCCESS> {
    date: Date;
    isQuickestDate: boolean;
}

export interface SetDeliverNotBeforeActionError extends ErrorAction<CheckoutActionTypes.SET_DELIVER_NOT_BEFORE_ERROR> {
}

export const setDeliverNotBefore: (date: Date, isQuickestDate: boolean) => SetDeliverNotBeforeAction = (date: Date, isQuickestDate: boolean) => ({
    type: CheckoutActionTypes.SET_DELIVER_NOT_BEFORE,
    date,
    isQuickestDate
});
setDeliverNotBefore[ACTION_CREATOR_NAME] = 'setDeliverNotBefore';

export type SetDeliverNotBeforeFunc = (...args: Parameters<typeof setDeliverNotBefore>) => void;

export function* setDeliverNotBeforeSaga({ date, isQuickestDate }: SetDeliverNotBeforeAction): BasketSagaReturnType {
    yield put<CheckoutActions>({
        type: CheckoutActionTypes.SET_DELIVER_NOT_BEFORE_START
    });

    try {
        const username = userHelper.getCurrentUserName();
        const state: AppState = yield select();

        /** date.getTime() returns LOCAL time in milliseconds */
        yield api.hybris.saveEca(username, state.basketState.basket!.guid, date.getTime());

        yield put<CheckoutActions>({
            type: CheckoutActionTypes.SET_DELIVER_NOT_BEFORE_SUCCESS,
            date,
            isQuickestDate
        });

        return true;
    } catch (error) {
        yield put<CheckoutActions>({
            type: CheckoutActionTypes.SET_DELIVER_NOT_BEFORE_ERROR,
            error: errorToBasketErrorModel(error, 'setDeliverNotBeforeSaga')
        });

        return false;
    }
}